export interface BusinessAddress {
  address: string;
  address2?: string;
  city: string;
  state: string;
  zip: string;
}

export interface AchPaymentTypeDetails {
  achAccountNumber: string;
  achAccountNumberMasked: string;
  achRoutingNumber: string;
  achBankName: string;
  achAccountType: string;
}

export interface CheckPaymentTypeDetails {
  checkPayableTo: string;
  checkMailingAddress: BusinessAddress;
}

export interface PaypalPaymentTypeDetails {
  paypalEmail: string;
}

export type DealerPaymentDetails =
  | AchPaymentTypeDetails
  | CheckPaymentTypeDetails
  | PaypalPaymentTypeDetails;

export enum PaymentType {
  PAYPAL = 'paypal',
  ACH = 'ach',
  CHECK = 'check',
}

export interface DealerVendor {
  id: number;
  name: string;
  url: string;
  address: string;
  address2: string;
  city: string;
  state: string;
  zip: string;
  phone: string;
  dealerVendorStatusId: number;
  paymentType: PaymentType;
  paymentTypeDetails: DealerPaymentDetails;
  createdByUserId: number;
  modifiedByUserId: number;
  createdByUserType: string;
  modifiedByUserType: string;
  created: string;
  modified: string;
  status: {
    id: number;
    name: string;
    description: string;
    isActiveState: boolean;
  };
  creatorName: string;
  creatorEmail: string | null;
  creatorEmailVerified: boolean;
}
